import grapesjs from "grapesjs";
import _ from "underscore";

const wpmNotificationsCustomStoragePlugin = (props) => {
  // create custom storage plugin
  grapesjs.plugins.add("wpmNotificationsCustomStorage", (editor) => {
    // storing data in hidden input
    editor.StorageManager.add("metaboxStorage", {
      /**
       * Load the data
       * @param  {Array} keys Array containing values to load, eg, ['gjs-components', 'gjs-styles', ...]
       * @param  {Function} clb Callback function to call when the load is ended
       * @param  {Function} clbErr Callback function to call in case of errors
       */

      load(keys, clb, clbErr) {
        const result = {};
        const savedConfig = JSON.parse(window.wpmNotifications);
        const savedEditorConfig = !!savedConfig.editor
          ? savedConfig.editor
          : [];
        savedEditorConfig.forEach((savedData) => {
          for (var savedKey in savedData) {
            if (keys.indexOf(savedKey) !== -1) {
              result[savedKey] = savedData[savedKey];
            }
          }
        });

        // Might be called inside some async method
        clb(result);
      },

      /**
       * Store the data
       * @param  {Object} data Data object to store
       * @param  {Function} clb Callback function to call when the load is ended
       * @param  {Function} clbErr Callback function to call in case of errors
       */
      store(data, clb, clbErr) {
        let mjmlCode = editor.runCommand("mjml-get-code");

        if (!!mjmlCode) {
          var emailHtml = _.escape(mjmlCode.html);

          data["emailhtml"] = emailHtml;
          props.updateEditorData(data);
        }

        // Might be called inside some async method
        clb();
      },
    });
  });
};


export default wpmNotificationsCustomStoragePlugin;